import { AppSpan, AppText, Button, CustomContainer, FlexRow, GridContainer, Icon, ScreenTitle } from "src/style"
import {browserName, mobileModel} from 'react-device-detect'
import { SidePopupLayout } from "src/component"
import SuccessGif from 'src/assets/gif/success.gif'
import ProfileCompletionIcon from 'src/assets/img/success-icon-safari.svg'

export const GeneratedCodeView: React.FC<any> = ({code, close}) => {

    return (
        <SidePopupLayout close={close}>
            <GridContainer topMargin="8">
                <CustomContainer width="15">
                    { (browserName != 'Safari' && mobileModel != 'iPhone') ?
                        <Icon src={SuccessGif} />
                        : <Icon src={ProfileCompletionIcon} />
                    }
                </CustomContainer>
                <ScreenTitle textSize="2.2" fontWeight="700" topMargin='2.5'>Access Code Generated</ScreenTitle>
                <FlexRow 
                    width="auto" sizeUnit="" gap='1.4' topMargin="2"
                >
                    <label className='cardless-withdrawal-code' >{code[0] || ''}</label>
                    <label className='cardless-withdrawal-code' >{code[1] || ''}</label>
                    <label className='cardless-withdrawal-code' >{code[2] || ''}</label>
                    <label className='cardless-withdrawal-code' >{code[3] || ''}</label>
                </FlexRow>
                <AppText align="center" topMargin="1">
                    Code Expires in 
                    <AppSpan color="#F20A0A" fontWeight="600"> 04:00:00 </AppSpan>
                </AppText>
                <Button 
                    width='8.4' height='4' topMargin='2' 
                    borderColor='#0D968F' hoverBgColor='#fff' 
                    hoverColor='#0D968F' titleSize='1.4'
                    onClick={close}
                >
                    Dismiss
                </Button>
            </GridContainer>
        </SidePopupLayout>
    )
}